import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import {
  Log,
  OffensivePlayCall,
  OffensivePlayLog,
  KickOffReturnPlayCall,
  KickOffReturnPlayLog,
  DefensivePlayCall,
  DefensivePlayLog,
  KickoffPlayCall,
  KickoffPlayLog,
  PuntPlayCall,
  PuntPlayLog,
  PuntReturnPlayCall,
  PuntReturnPlayLog,
  FieldGoalPlayCall,
  FieldGoalPlayLog,
  FieldGoalBlockPlayCall,
  FieldGoalBlockPlayLog,
  OffensePlayCallLog,
  PenaltyLog,
} from "../../../../types/LogTypes";
import { theme } from "../../../../styles/Theme";
import { OffenseLogDetails } from "./OffenseLogDetails";
import { DefenseLogDetails } from "./DefenseLogDetails";
import { KickOffLogDetails } from "./KickOffLogDetails";
import { KickOffReturnLogDetails } from "./KickOffReturnLogDetails";
import { PuntLogDetails } from "./PuntLogDetails";
import { PuntReturnLogDetails } from "./PuntReturnLogDetails";
import { FieldGoalLogDetails } from "./FieldGoalLogDetails";
import { FieldGoalBlockLogDetails } from "./FieldGoalBlockLogDetails";

interface LogDetailsProps {
  log: Log;
}

export const LogDetails: React.FC<LogDetailsProps> = ({ log }) => {
  if (!log.play_type) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">No play type specified</Typography>
      </Box>
    );
  }

  switch (log.play_type) {
    case "OFFENSE":
      return (
        <OffenseLogDetails
          playCall={log.play_call as OffensePlayCallLog}
          playLog={log.play_log as OffensivePlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    case "DEFENSE":
      return (
        <DefenseLogDetails
          playCall={log.play_call as DefensivePlayCall}
          playLog={log.play_log as DefensivePlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    case "KICKOFF_RETURN":
      return (
        <KickOffReturnLogDetails
          playCall={log.play_call as KickOffReturnPlayCall}
          playLog={log.play_log as KickOffReturnPlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );

    case "KICKOFF":
      return (
        <KickOffLogDetails
          playCall={log.play_call as KickoffPlayCall}
          playLog={log.play_log as KickoffPlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    case "PUNT":
      return (
        <PuntLogDetails
          playCall={log.play_call as PuntPlayCall}
          playLog={log.play_log as PuntPlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    case "PUNT_RETURN":
      return (
        <PuntReturnLogDetails
          playCall={log.play_call as PuntReturnPlayCall}
          playLog={log.play_log as PuntReturnPlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    case "FIELD_GOAL":
      return (
        <FieldGoalLogDetails
          playCall={log.play_call as FieldGoalPlayCall}
          playLog={log.play_log as FieldGoalPlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    case "FIELD_GOAL_BLOCK":
      return (
        <FieldGoalBlockLogDetails
          playCall={log.play_call as FieldGoalBlockPlayCall}
          playLog={log.play_log as FieldGoalBlockPlayLog}
          penalties={log.penalties as PenaltyLog[]}
        />
      );
    default:
      return (
        <Box sx={{ p: 2 }}>
          <Typography color="error">
            Unknown play type: {log.play_type}
          </Typography>
        </Box>
      );
  }
};
